import { render } from "./HDNA.vue?vue&type=template&id=4d288541&scoped=true"
import script from "./HDNA.vue?vue&type=script&lang=js"
export * from "./HDNA.vue?vue&type=script&lang=js"

import "./HDNA.vue?vue&type=style&index=0&id=4d288541&lang=scss&scoped=true"

import exportComponent from "/Users/mateomateus/Documents/Rabinovici/hp-blueprint-presentation/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4d288541"]])

export default __exports__